/**
 * DemoSessionBoot.jsx — Sesión anónima del tenant demo de la landing.
 *
 * Si la app corre bajo /demo/*, pide un token demo al server (solo lectura),
 * lo instala en el resolver de axios e hidrata Redux con el usuario/tenant
 * demo — con eso TenantRoute y ProtectedRoute pasan solos y se renderiza la
 * app REAL completa. window.__CD_DEMO__ activa además el sandbox de
 * escrituras en api.js (las mutaciones no viajan: se responden sintéticas y
 * los reducers .fulfilled las aplican solo en la memoria de esta pestaña).
 */
import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import api from '../services/api'
import { setSessionToken } from '../utils/authToken'
import { demoSessionLoaded } from '../store/slices/authSlice'

export const esRutaDemo = (pathname) => pathname === '/demo' || pathname.startsWith('/demo/')

export default function DemoSessionBoot() {
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const bootedRef = useRef(false)

  useEffect(() => {
    if (!esRutaDemo(pathname) || bootedRef.current) return
    bootedRef.current = true
    window.__CD_DEMO__ = true

    api
      .get('/demo/session')
      .then((res) => {
        const { token, user, tenant } = res.data || {}
        if (!token) throw new Error('sin token')
        setSessionToken(token)
        dispatch(demoSessionLoaded({ user, tenant }))
      })
      .catch((err) => {
        // Sin demo no hay nada que mostrar bajo /demo: volver a la landing.
        console.warn('[Demo] No se pudo iniciar la sesión demo:', err?.message)
        window.location.replace('/')
      })
  }, [pathname, dispatch])

  return null
}
